const ONE_MINUTE_IN_MS = 60_000
export const CHAT_TIMEOUT_MESSAGE = 2.5 * ONE_MINUTE_IN_MS
export const END_CHAT_TIMEOUT = 0.5 * ONE_MINUTE_IN_MS
export const CALENDLY_PORTAL_ID = 'calendly'
export const EMBEDDED_CHAT_KEY = 'embedded'
export const EMBEDDED_CHAT_VALUE = 'yes'
export const TEMPLATE_PAGE_CHAT_KEY = 'isTemplatePage'
export const TEMPLATE_PAGE_CHAT_VALUE = 'yes'
